import { useEffect, useState } from "react";
import FilePreview from "../components/FilePreview";

const DocumentPreview = () => {
  const [previewFile, setPreviewFile] = useState(null);

  useEffect(() => {
    document.documentElement.style.overflow = "hidden";
    document.body.style.overflow = "hidden";

    return () => {
      document.documentElement.style.overflow = "";
      document.body.style.overflow = "";
    };
  }, []);

  useEffect(() => {
    const handleMessage = (event) => {
      if (event.data?.key !== "document-preview-file") {
        return;
      }

      const file = event.data?.value;
      if (!file?.downloadURL) {
        return;
      }

      setPreviewFile({
        name: file.name || "Document",
        downloadURL: file.downloadURL,
        mimeType: file.mimeType,
      });
    };

    window.addEventListener("message", handleMessage);
    window.parent?.postMessage({ key: "document-preview-ready" }, "*");

    return () => window.removeEventListener("message", handleMessage);
  }, []);

  const handleClose = () => {
    window.parent?.postMessage({ key: "close-document-preview" }, "*");
  };

  if (!previewFile) {
    return null;
  }

  return <FilePreview file={previewFile} onClose={handleClose} />;
};

export default DocumentPreview;
